import { jsx as _jsx } from "react/jsx-runtime";
import React, { useId } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Drawer, Input } from '@ibk/shared-ui';
import styles from './BpoDemo.module.css';
import { demoTranslations } from './demoTranslations';
export function useDemoText() {
    const { currentLanguage } = useTranslation();
    const dictionary = demoTranslations[currentLanguage] ?? demoTranslations['pt-BR'];
    return (key) => dictionary[key];
}
export function MockNotice() {
    const text = useDemoText();
    return (_jsx("p", { className: styles.notice, title: text('notice'), children: text('demonstration') }));
}
export function DemoDrawer({ isOpen, children, ...props }) {
    if (!isOpen)
        return null;
    return (_jsx(Drawer, { ...props, isOpen: true, customStyles: {
            drawer: styles.drawer,
            'drawer-body': styles.drawerBody,
            'drawer-header-container': styles.drawerHeader,
            'drawer-header-subtitle': styles.drawerSubtitle,
        }, children: _jsx("div", { className: styles.drawerBodyContent, children: children }) }));
}
export function DemoButton({ children, onClick, disabled, secondary = false, }) {
    return (_jsx(Button, { variant: secondary ? 'secondary' : 'primary', "data-variant": secondary ? 'secondary' : 'primary', size: 'small', dataTestId: 'bpo-demo-action', onClick: onClick, disabled: disabled, children: children }));
}
export function DemoField({ label, value, onChange, type = 'text', maxLength = 255, }) {
    const id = useId();
    return (_jsx(Input, { id: id, "aria-label": label, label: label, value: value, type: type, maxLength: maxLength, dataTestId: 'bpo-demo-field', size: 'small', onChange: e => onChange(e.target.value) }));
}
export const digits = (value) => value.replace(/\D/g, '');
export const cpfMask = (value) => digits(value)
    .slice(0, 11)
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
export const phoneMask = (value) => digits(value)
    .slice(0, 11)
    .replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
export const validEmail = (value) => {
    if (!value || value.length > 254 || /\s/.test(value))
        return false;
    const parts = value.split('@');
    if (parts.length !== 2 || !parts[0])
        return false;
    const labels = parts[1].split('.');
    return labels.length > 1 && labels.every(label => label.length > 0);
};
